import { Injectable } from '@angular/core';
import {HttpParams} from '@angular/common/http';
import {Http} from '@angular/http';
import {environment} from '../../../../environments/environment';
declare var DDP_ENV: any;

@Injectable({
  providedIn: 'root'
})
export class AuthenticationServiceService {
  readonly baseURL = DDP_ENV.adminFunctionUrl;

  constructor(private _http: Http) { }

  getAllAuthentications(page, size, regexPattern) {
    return this._http.get(this.baseURL + '/authentications?' +
        'page=' + page +
        '&size=' + size +
        '&regexPattern=' + regexPattern);
  }

  addAuthentication(macAddress, testAuthenticationData) {
      return this._http.post(this.baseURL + '/authentications/macaddress/' + macAddress + '/' + testAuthenticationData,'');
  }

  removeAuthenticationByMac(macAddress) {
    return this._http.delete(this.baseURL + '/authentications/macaddress/' + macAddress );
  }
}
